
import { SettingsIcon } from "vue-feather-icons";
import Accordion from /* webpackChunkName: "AccordionSingle" */ "../../components/ui/AccordionSingle";
import FileInput from /* webpackChunkName: "FileInput" */ "~/components/file-io/FileInput";
import AdvancedOptions from /* webpackChunkName: "AdvancedOptions" */ "~/components/file-io/AdvancedOptions";
import ThumbList from /* webpackChunkName: "ThumbList" */ "~/components/file-io/file/ThumbList"

export default {
  name: "SingleTemplate",
  components: {
    SettingsIcon,
    FileInput,
    AdvancedOptions,
    Accordion,
    ThumbList,
    PreviewLayout: () => import(/* webpackChunkName: "PreviewLayout" */ "./PreviewLayout"),
    BannerContainer: () => import( /* webpackChunkName: "Banner" */ '~/components/ui/BannerContainer'),
  },
  data: () => ({
    isAOVisible: false,
  }),
  computed: {
    info() { return this.$store.state.info },
    list() { return this.$store.state.list },
    hasFiles() { return !!this.$store.state.list.length },
    selectedTarget() { return this.info.target.ext },
    merging() { return this.$store.state.advancedSetting.merging },
    pageUid() { return this.merging ? 'root' : 'page' },
    customVariables() { return this.info.customVariables },
    enablePreview() { return this.customVariables ? this.customVariables.enablePreview : false },
    enableSort() { return this.customVariables ? this.customVariables.enableSort : false },
    selectedPreviewItem () { return this.$store.state.advancedSetting.selectedPreviewItem },
    target() {
      if (this.list.length) {
        const { targetForFile } = this.$store.state.advancedSetting;
        let target = "";
        this.list.forEach(({ id }, i) => {
          if (!targetForFile[id] || !targetForFile[id].name) {
            target = "";
          } else if (!i) {
            target = targetForFile[id].name.toLowerCase();
          } else if (target !== targetForFile[id].name.toLowerCase()) {
            target = "";
          }
        });
        return target ? target : this.selectedTarget;
      } else {
        return this.selectedTarget;
      }
    },
    showAdvancedOptions() {
      // preview is enabled, don't show extra advanced-options
      if (this.info.targetExt === 'apng') return false;
      if (this.enablePreview) { return false }
      if (this.hasFiles) return this.merging
      return this.info.advancedOptions && this.info.advancedOptions.length
    },
    slug() {
      if (this.merging) {
        return this.merging;
      }
      if (this.info.slug) {
        return this.info.slug;
      }
      return this.info.source.ext + "-to-" + this.info.target.ext;
    },
  },
  watch: {
    hasFiles(val) {
      if (val) {
        // eslint-disable-next-line no-inner-declarations
        function findPos(obj) {
          let curtop = 0;
          if (obj.offsetParent) {
            do {
              curtop += obj.offsetTop - 80;
              // eslint-disable-next-line no-cond-assign
            } while ((obj = obj.offsetParent));
            return [curtop];
          }
        }
        window.scroll(0, findPos(document.getElementById("single-template")));
      }
    }
  },
  created() {
    this.setupBreadCrumbs()
  },
  mounted() {
    if (this.customVariables && this.customVariables.enablePreview) {this.$store.commit("advancedSetting/setRootSetting", true);}

    if (this.info.source && this.info.target) {
      this.$store.dispatch("advancedSetting/setOptions", {
        slug: this.info.source.ext + "-to-" + this.info.target.ext,
        srcExt: this.getSourceExt(),
        list: this.info.advancedOptions,
        lang: this.$i18n.locale,
        targetExt: this.target,
      });
    }

    this.$store.dispatch(
      "advancedSetting/setDefaultTarget",
      this.info.target.slug
    );

    if (this.info.targets) {
      this.targetList = [];
      for (const type in this.info.targets) {
        if (this.info.targets[type].length) {
          this.targetList.push({
            label: type,
            links: [...this.info.targets[type]]
              .sort((a, b) => (a.device ? 1 : 0) - (b.device ? 1 : 0))
              .map((v) => ({ label: v.name.toUpperCase(), value: v.name })),
          });
        }
      }
    }
  },
  methods: {
    convertFiles() {
      this.$store.commit("setList", this.$refs.thumbList.sortedList);
      this.$bus.$emit("goToDownloadPage");
    },
    getSourceExt() {
      if (this.info.sourceExt) return this.info.sourceExt;
      return this.info.source ? this.info.source.ext : null;
    },
    setupBreadCrumbs () {
      if (this.info.type === 'apng') return
      this.$store.commit("updateBreadcrumbs", [
        {
          url: this.localePath(
            `/${this.info.target.group.toLowerCase()}-converter`
          ),
          label: this.info.target.group + " " + this.$t("converter"),
        },
        {
          url: this.localePath(`/${this.info.target.slug}-converter`),
          label: this.info.target.name + " " + this.$t("converter"),
        },
        {
          url: this.$route.path,
          label: this.info.header_h1,
        },
      ]);
    }
  },
};
